import { flushSync } from "react-dom";

const FADE_IN_MS = 160;
const FADE_OUT_MS = 240;

/**
 * Switches the theme behind a cover in the new theme's colours, with a small loader, so no part
 * of the page is ever seen half-switched (old text on the new background).
 * @param {{ bg: string, accent: string }} target colours of the theme being switched to
 * @param {() => void} apply makes the switch; it is flushed synchronously while covered
 * @since NEXT_VERSION
 */
export function runBehindVeil({ bg, accent }, apply) {
  const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
  if (reduceMotion || !document.body) {
    apply();
    return;
  }

  // A second switch while one is running replaces its cover.
  document.querySelector(".theme-veil")?.remove();
  const veil = document.createElement("div");
  veil.className = "theme-veil";
  veil.setAttribute("aria-hidden", "true");
  veil.style.background = bg;
  veil.style.color = accent;
  veil.innerHTML = '<span class="theme-veil-loader"><i></i><i></i><i></i></span>';
  document.body.appendChild(veil);
  requestAnimationFrame(() => veil.classList.add("is-shown"));

  window.setTimeout(() => {
    flushSync(apply);
    // Two frames: the re-themed page is painted before the cover lifts.
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        veil.classList.remove("is-shown");
        window.setTimeout(() => veil.remove(), FADE_OUT_MS);
      })
    );
  }, FADE_IN_MS);
}
